"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _utils = require("@/utils");
var _index = _interopRequireDefault(require("./components/ImportExcel/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ImportExcel: _index.default
  },
  data: function data() {
    var _this = this;
    return {
      pageName: 'taskAssignment',
      optConfig: {},
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      list: [],
      total: 0,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      searchVal: {
        taskDescriptionList: [],
        rsmEmpNo: '',
        rsmEmpName: '',
        asmEmpNo: '',
        asmEmpName: '',
        srEmpNo: '',
        srEmpName: '',
        deadlineTimeStart: '',
        deadlineTimeEnd: ''
      },
      taskDescriptionList: [],
      startStartDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.deadlineTimeEnd) {
            return time.getTime() > new Date(_this.searchVal.deadlineTimeEnd).getTime();
          }
        }
      },
      startEndDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.deadlineTimeStart) {
            return time.getTime() < new Date(_this.searchVal.deadlineTimeStart).getTime() - 3600 * 1000 * 24;
          }
        }
      }
    };
  },
  computed: {},
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    setTimeout(function () {
      _this2.fetchTaskDescriptionData();
      _this2.searchData();
    }, 300);
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    fetchTaskDescriptionData: function fetchTaskDescriptionData() {
      var _this3 = this;
      var param = {};
      console.log(param);
      this.$api.taskAssignment.getTaskDescriptionList(param).then(function (res) {
        console.log(res);
        if (res.success) {
          _this3.taskDescriptionList = res.data;
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      });
    },
    fetchData: function fetchData() {
      var _this4 = this;
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      console.log(param);
      this.listLoading = true;
      this.$api.taskAssignment.getTaskAllocatedList(param).then(function (res) {
        _this4.listLoading = false;
        _this4.list = res.data.items;
        _this4.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this4.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal.taskDescriptionList = [];
      this.searchVal.rsmEmpNo = '';
      this.searchVal.rsmEmpName = '';
      this.searchVal.asmEmpNo = '';
      this.searchVal.asmEmpName = '';
      this.searchVal.srEmpNo = '';
      this.searchVal.srEmpName = '';
      this.searchVal.deadlineTimeStart = '';
      this.searchVal.deadlineTimeEnd = '';
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    refreshData: function refreshData() {
      this.fetchData();
    },
    downloadExcel: function downloadExcel() {
      var _this5 = this;
      if (this.isLoading) return;
      this.isLoading = true;
      var fileName = this.$t('sfe.taskassignment.common.fileName');
      this.$api.taskAssignment.exportTaskAllocated(this.searchVal).then(function (res) {
        _this5.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function (err) {
        _this5.$message.error(_this5.$t('sfe.taskassignment.common.exportFailed'));
        console.log(err);
        _this5.isLoading = false;
      });
    }
  }
};